export default {
  CAMPAIGN_ADHOC_NOTIFICATION: 'campaign_adhoc_notification',
};
